import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        VRow,
        { staticClass: "mt-0", attrs: { "no-gutters": "" } },
        [_c(VSpacer)],
        1
      ),
      _c(
        VRow,
        { attrs: { "no-gutters": "" } },
        [
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _c("v-card-widget", { attrs: { title: "Informações" } }, [
                _c(
                  "div",
                  { attrs: { slot: "widget-content" }, slot: "widget-content" },
                  [
                    _c(
                      VRow,
                      { attrs: { "no-gutters": "" } },
                      [
                        _vm.nome !== ""
                          ? _c(VCol, { attrs: { cols: "6" } }, [
                              _c("span", { staticClass: "font-weight-bold" }, [
                                _vm._v("Usuário(a): "),
                              ]),
                              _c("span", { staticClass: "font-weight-light" }, [
                                _vm._v(_vm._s(_vm.nome)),
                              ]),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VRow,
        [
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _c(
                "v-card-widget",
                {
                  attrs: {
                    title: _vm.titulo ? _vm.titulo : "Informações",
                    "enable-actions": "",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      attrs: { slot: "widget-content" },
                      slot: "widget-content",
                    },
                    [
                      _c(
                        VRow,
                        [
                          _c(
                            VTooltip,
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function ({ on }) {
                                    return [
                                      _c(
                                        VBtn,
                                        _vm._g(
                                          {
                                            attrs: {
                                              absolute: "",
                                              color: "secondary",
                                              dark: "",
                                              fab: "",
                                              right: "",
                                              top: "",
                                            },
                                            on: { click: _vm.loadTutorial },
                                          },
                                          on
                                        ),
                                        [_c(VIcon, [_vm._v("help")])],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            },
                            [
                              _c("span", [
                                _vm._v("Em caso de dúvidas, clique aqui"),
                              ]),
                            ]
                          ),
                          _c(
                            VTooltip,
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function ({ on }) {
                                    return [
                                      _c(
                                        VBtn,
                                        _vm._g(
                                          {
                                            staticClass: "mr-16",
                                            attrs: {
                                              absolute: "",
                                              color: "secondary",
                                              dark: "",
                                              fab: "",
                                              right: "",
                                              top: "",
                                            },
                                            on: {
                                              click:
                                                _vm.visualizarTermoResponsabilidade,
                                            },
                                          },
                                          on
                                        ),
                                        [_c(VIcon, [_vm._v("description")])],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  "Para visualizar o termo de responsabilidade novamente, clique aqui"
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._t("body"),
                    ],
                    2
                  ),
                  _c(
                    "div",
                    {
                      attrs: { slot: "widget-actions" },
                      slot: "widget-actions",
                    },
                    [
                      _c(
                        VRow,
                        { attrs: { "no-gutters": "" } },
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "12" } },
                            [_vm._t("actions")],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("dialog-termo-responsabilidade", {
        attrs: { "dialog-props": _vm.dialogs.dialogTermoResponsabilidade },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }